import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  timePeriodSelectorContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
